import "./VehiclePrivacy.scss";
import iconPathURL from "../../Common/iconPath";
import ContactFooter from "../../Common/ContactFooter/contactFooter";

const docPath = process.env.PUBLIC_URL + "/assets/docs/";
const LEGAL_EMAIL = "legalandcompliance_mbrdi@mercedes-benz.com";

export default function VehiclePrivacyPolicy() {
  return (
    <div className="csr-container">
      <div className="csr-banner-container">
        <img
          src={iconPathURL("legal/legal.png")}
          className="banner-image"
          alt="Legal and Compliance banner"
        />

        <div className="banner-content">
          <h2 className="banner-title">Legal and Compliance</h2>
        </div>
      </div>

      <section className="text-container-section col-xs-12 col-sm-12 col-md-8 col-lg-8">
        <div className="first-box">
          <h2 className="sub-title title-content">
            Data Collection Vehicle Privacy Policy
          </h2>
          <p className="first-text address">
            The below documents serves as a privacy notice, declaration, and
            disclaimer regarding the collection, processing, and use of video,
            image, audio, and sensor data by Mercedes-Benz Research and
            Development India Private Limited (MBRDI) for research, development,
            and testing purposes related to driving assistance systems,
            automated driving, drive functions, and other related services. This
            notice is aligned with the Digital Personal Data Protection Act,
            2023 (DPDP Act).
          </p>
        </div>

        <div className="document-links">
          <h2 className="title-content">Click here for:</h2>
          <a
            className="email-link"
            target="_blank"
            rel="noopener noreferrer"
            href={`${docPath}EN_MBRDI Data Collection Vehicle - Privacy Policy.pdf`}
            aria-label="Download MBRDI Data Collection Vehicle Privacy Policy PDF"
          >
            EN_MBRDI Data Collection Vehicle - Privacy Policy
          </a>
        </div>
      </section>

      <ContactFooter
        html={() => (
          <span>
            For any queries related to Legal & Compliance, please write to
            <a
              className="email-link"
              href={`mailto:${LEGAL_EMAIL}?subject=Legal%20and%20Compliance%20Query`}
            >
              {" " + LEGAL_EMAIL}
            </a>
          </span>
        )}
        screen="Legal & Compliance"
        label="For any queries related to Legal & Compliance, please write to "
      />
    </div>
  );
}
